<template>
  <div class="cause-contain">
    <div class="mt24" v-for="(item,index) in fileList" :key="index">
      <div class="title">{{item.title}}</div>
      <div class="content">
        <!--  -->
          <div class="list">
              <div class="edge">
                <div class="text">{{item.name}}.{{item.type}}</div>
                <div class="pic">
                  <img v-if="item.type=='pdf'" src="../../../assets/appraise/ic_pdf.png"/>
                  <img v-if="item.type=='doc'" src="../../../assets/appraise/ic_doc.png"/>
                  <img v-if="item.type=='exl'" src="../../../assets/appraise/ic_exl.png"/>
                </div>
              </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'file',
        props: {
            'id': String,
            'fileList': Array
        },
        data () {
            return {

            }
        },
        mounted () {

        }
    }
</script>

<style lang="less" scoped>
.cause-contain{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .mt24{
    margin-top: 24px;
  }
  .title{
    height:20px;
    font-size:16px;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:20px;
  }
  .content{
    margin-top:12px;
    background:rgba(255,255,255,1);
    box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
    border-radius:5px;
    .list{
      border-bottom: solid 1px #EEEEEE;
      .edge{
        padding:16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .text{
          flex: 1;
          font-size:16px;
          padding-right: 45px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          line-height:24px;
          color:rgba(51,51,51,1);
           text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
        }
        .pic{
          width:34px;
          height:38px;
          img{
            width:34px;
            height:38px;
          }
        }
      }
    }
    .list:last-child{
      border-bottom: 0;
    }
  }
}
</style>
